import React from "react";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { Button, ButtonColour, ButtonSize } from "@trussle/external-components";
import { StaticImage } from "gatsby-plugin-image";
import { IContentfulHeroProps } from "../../types/IHero";
import "./styles.scss";
import { PanelWrapper } from "../PanelWrapper";
import { SmartBuyerCard } from "./Card";
import { trackEvent } from "../../helpers/analytics";

const Images = () => (
  <div>
    <div className="hero-smartbuyer-betterv2-across-modules-left">
      <StaticImage
        src="../../static/purchase-bg-left.png"
        alt=""
        placeholder="none"
        height={671}
      />
    </div>
    <div className="hero-smartbuyer-betterv2-across-modules-right">
      <StaticImage
        src="../../static/purchase-bg-right.png"
        alt=""
        placeholder="none"
        height={671}
      />
    </div>
  </div>
);

const HeroSmartBuyer: React.FC<IContentfulHeroProps> = ({
  heading1,
  heading2,
  firstCta,
}) => {
  const handleClick = async () => {
    await trackEvent("SmartBuyer cta clicked", {
      module: "HeroSmartBuyer",
      element_type: "Button",
      section: "Hero",
    });

    window.location.assign(firstCta?.url || "https://better.co.uk/smart-buyer");
  };

  return (
    <PanelWrapper isBetterV2 elementsBeforeContent={<Images />}>
      <div className="hero-smartbuyer-betterv2-container">
        <div className="hero-smartbuyer-betterv2-left">
          <div className="hero-smartbuyer-betterv2-heading1">
            {heading1 && renderRichText(heading1)}
          </div>
          {heading2 && renderRichText(heading2)}
          <Button
            colour={ButtonColour.DarkYellow}
            className="hero-smartbuyer-betterv2-cta"
            type="button"
            onClick={handleClick}
            size={ButtonSize.Large}
          >
            {firstCta?.title || "Get started"}
          </Button>
        </div>
        <div className="hero-smartbuyer-betterv2-right">
          <SmartBuyerCard />
        </div>
      </div>
    </PanelWrapper>
  );
};

export default HeroSmartBuyer;
